import { render, staticRenderFns } from "./BeginnerCourse.vue?vue&type=template&id=694e4d59"
import script from "./BeginnerCourse.vue?vue&type=script&lang=js"
export * from "./BeginnerCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports